
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    text: String,
  },
})
export default class ButtonShare extends Vue {
  text!: string;
}
